exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".course-container{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: end;\n      align-content: flex-end;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-flow: wrap;\n      flex-flow: wrap;\n  width: 100%;\n  margin-bottom: 25px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/course/courses.component.css
// module id = 784
// module chunks = 0